// JS document for the Search elements -- the search result's page search bar

//---------------------------------------------------------------//
// Handle the Search Results page element
//---------------------------------------------------------------//

// allow submit of form via the search icon faux button element
$('#search-bar-page-container .faux-search-btn').on('click', function () {
  $('#search-bar-page-container form').submit();
});
